import { IPosition, IRange, Uri, editor } from "monaco-editor/esm/vs/editor/editor.api";
import { FilePath, SelectionRange } from "../../../types";

export class TypeDefinitionOpener implements editor.ICodeEditorOpener {
  constructor(private onDefinitionOpened?: (filePath: FilePath, selection?: SelectionRange) => void) {
  }

  openCodeEditor(_source: editor.ICodeEditor, resource: Uri, selectionOrPosition?: IRange | IPosition | undefined): boolean | Promise<boolean> {
    if (!this.onDefinitionOpened)
      return false;

    const isPosition = (selection?: IRange | IPosition): selection is IPosition => {
      return (selection as IPosition).lineNumber !== undefined;
    };
    const isRange = (selection?: IRange | IPosition): selection is IRange => {
      return (selection as IRange).startLineNumber !== undefined;
    };

    if (selectionOrPosition && isPosition(selectionOrPosition)) {
      const selection: SelectionRange = {
        startLineNumber: selectionOrPosition.lineNumber,
        endLineNumber: selectionOrPosition.lineNumber,
        startColumn: selectionOrPosition.column,
        endColumn: 1000
      }
      this.onDefinitionOpened(resource.path, selection)
      return true;
    }
    if (selectionOrPosition && isRange(selectionOrPosition)) {
      this.onDefinitionOpened(resource.path, { ...selectionOrPosition })
      return true;
    }

    this.onDefinitionOpened(resource.path)
    return true;
  }
}